import styled from "styled-components";

export const ReferralWrapper = styled("div")(() => {
  return {
    borderRadius: "1rem",
    backgroundColor: "var(--color-background)",
    "& .heading-row": {
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: "1rem",
      marginBlockEnd: "0",
      "& span": {
        fontFamily: "Poppins",
        fontWeight: 700,
        fontSize: "1.2rem",
        color: "var(--color-text)",
        letterSpacing: "0.02em",
        textTransform: "uppercase",
      },
      "& p": {
        marginBlock: "0.35rem 0 0",
        color: "var(--color-text-light)",
        fontSize: ".9rem",
      },
      "& .total-pill": {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "74px",
        minHeight: "34px",
        padding: "0 0.85rem",
        borderRadius: "999px",
        backgroundColor: "var(--color-primary-hover)",
        color: "var(--color-primary)",
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 700,
        whiteSpace: "nowrap",
      },
    },
    "& .referrals-table": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.9rem",
      overflowX: "auto",
      backgroundColor: "var(--color-neutral)",
    },
    "& .referrals-table table": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      minWidth: "950px",
    },
    "& th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },
    "& th:first-of-type": {
      borderTopLeftRadius: "12px",
    },
    "& th:last-of-type": {
      borderTopRightRadius: "12px",
    },
    "& td": {
      border: "none",
      borderBottom: "1px solid #edf1f6",
      color: "var(--color-text)",
      padding: "0.95rem 1rem",
      minWidth: "unset",
      fontSize: "0.88rem",
      verticalAlign: "middle",
      position: "relative",
    },
    "& .referral-state": {
      margin: "0 var(--cardPadding) var(--cardPadding)",
      minHeight: "220px",
      borderRadius: "12px",
      backgroundColor: "var(--color-background)",
      color: "var(--color-text-light)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: 600,
    },
    "& .empty-state": {
      flexDirection: "column",
      gap: "0.35rem",
      textAlign: "center",
      "& strong": {
        color: "var(--color-text)",
        fontSize: "16px",
      },
      "& span": {
        maxWidth: "360px",
        color: "var(--color-text-light)",
        fontWeight: 400,
      },
    },
    "& .table-footer": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "1rem",
      borderTop: "1px solid #edf1f6",
      backgroundColor: "var(--color-neutral)",
      fontSize: "0.88rem",
      color: "var(--color-text)",
    },
    "& .pagination": {
      display: "flex",
      gap: "0.5rem",
      alignItems: "center",
    },
    "& .page-chip": {
      padding: "0.5rem 0.75rem",
      border: "1px solid #d9dee7",
      backgroundColor: "var(--color-neutral)",
      color: "var(--color-text)",
      borderRadius: "0.45rem",
      cursor: "pointer",
      fontSize: "0.85rem",
      fontWeight: 600,
      transition: "all 0.2s ease",
      "&:hover:not(:disabled)": {
        backgroundColor: "var(--color-primary-hover)",
        borderColor: "var(--color-primary)",
      },
      "&.active": {
        backgroundColor: "var(--color-primary)",
        color: "white",
        borderColor: "var(--color-primary)",
      },
      "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
      },
    },
  };
});
